import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { Edit } from 'react-admin';

import LeaveConfirm from '../../core/components/LeaveConfirmWrapper';
import FormTitleBar from '../../core/components/FormTitleBar';
import NavigationPrompt from '../../core/components/NavigationPrompt';
import { getInitials, removePathEnd } from '../../core/utils';
import TenantConfigurationForm from './TenantConfigurationForm.js';

const styles = () => ({
  gridTab: {
    marginTop: '-17px !important'
  },
  noActions: {
    marginTop: '0px'
  }
});

const TenantConfigurationTitle = ({ record }) => {
  return (
    <FormTitleBar
      name={record.name}
      showAvatar={true}
      avatarContent={getInitials(record.name)}
    />
  );
};

class TenantConfigurationEdit extends React.Component {
  state = {
    whenBlockNavigation: false
  };

  handleFormIsDirty = dirty => {
    // Block navigation if the form is dirty
    this.setState({ whenBlockNavigation: dirty });
  };

  render() {
    const { whenBlockNavigation } = this.state;
    const {
      classes,
      hasCreatePermission,
      hasEditPermission,
      hasDeletePermission,
      ...rest
    } = this.props;
    const displayToolbar = this.props.match.isExact;

    return (
      <React.Fragment>
        <NavigationPrompt
          when={whenBlockNavigation}
          adjustMatchingPath={removePathEnd}
          hasEditPermission={hasEditPermission}
        >
          {(isOpen, onConfirm, onCancel) => (
            <LeaveConfirm
              isOpen={isOpen}
              onConfirm={onConfirm}
              onClose={onCancel}
            />
          )}
        </NavigationPrompt>
        <Edit
          {...rest}
          undoable={false}
          title={<TenantConfigurationTitle />}
          classes={{ noActions: classes.noActions }}
        >
          <TenantConfigurationForm
            {...rest}
            displayToolbar={displayToolbar}
            handleFormIsDirty={this.handleFormIsDirty}
            hasEditPermission={hasEditPermission}
          />
        </Edit>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(TenantConfigurationEdit);
